<template>
  <div>
    <b-card>
      <div class="m-2">
        <!-- Table Top / Header Section -->
        <b-row class="align-items-center">
          <!-- Text Column -->
          <b-col md="6" class="mb-4 mb-md-0">
            <h2 class="fw-normal">
              Tingkatkan pengetahuan produk
              <span class="text-primary fw-bold">Digital Connectivity</span>
              dan optimalkan penjualan melalui pendampingan
              <span class="text-dark fw-bold">Consultative Selling</span>.
            </h2>
            <b-button variant="primary" class="mt-2" :to="{ name: 'consultative-selling-reservation' }">Reservation</b-button>
          </b-col>

          <!-- Image Column -->
          <b-col md="6" class="text-center">
            <img
              :src="imgConsultativeSelling"
              alt="Consultative Selling"
              class="img-fluid"
              style="max-height: 400px"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card>
      <!-- Larger screen than mobile -->
      <ul class="nav nav-pills mb-2">
        <li class="nav-item" v-for="status in statuses" :key="status.value">
          <a
            class="nav-link"
            :class="{ active: currentStatus === status.value }"
            href="#"
            @click.prevent="filterByStatus(status.value)"
          >
            {{ status.label }}
          </a>
        </li>
      </ul>
      <div class="d-none d-md-flex">
        <b-table
          responsive
          :items="filteredReservations"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="isBusy"
          class="w-100"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
              <strong class="text-secondary">Loading...</strong>
            </div>
          </template>

          <template #cell(action)="row">
            <div class="d-flex justify-content-center align-items-center text-center">
              <b-button
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="secondary"
                @click="DetailReservation(row.item)"
              >
                <feather-icon size="14" icon="BookIcon" />
              </b-button>
              <b-button
                v-if="row.item.request_status === 'RESCHEDULE'"
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="warning"
                @click="RescheduleInfo(row.item)"
              >
                <feather-icon size="14" icon="ClockIcon" />
              </b-button>
             <b-button
                v-if="row.item.request_status === 'REQUESTED'"
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="primary"
                @click="deleteReservation(row.item)"
              >
                <feather-icon size="14" icon="TrashIcon" />
              </b-button>
            </div>
          </template>
          <template #cell(product_category)="data">
            <div v-html="formatProduct(data.item.product_category, 'primary')"></div>
          </template>
          <template #cell(product_name)="data">
            <div v-html="formatProduct(data.item.product_name, 'warning')"></div>
          </template>
          <template #cell(request_status)="data">
            <div v-html="formatBadgesStatus(data.item.request_status)"></div>
          </template>
          <template #cell(createdat)="reservationRequest">
            <div>
              {{
                reservationRequest.item.createdat
                  ? $moment(reservationRequest.item.createdat).format('dddd, Do MMMM YYYY')
                  : '-'
              }}
            </div>
          </template>
        </b-table>
      </div>
      <!-- Mobile screen -->
      <div class="d-flex d-md-none flex-column">
        <!-- Loading -->
        <div v-if="isBusy" class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
        <!-- Data -->
        <div v-if="!isBusy && filteredReservations.length == 0" class="text-center text-danger my-2">
          <strong class="text-secondary">No data</strong>
        </div>
        <b-row
          v-if="!isBusy && filteredReservations.length > 0"
          v-for="(item, index) in filteredReservations"
          :key="item.id"
          class="mb-3 list-item"
        >
          <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
            <strong class="flex-grow-1 truncate">{{ item.am_name }}</strong>
            <div>
              <b-button
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="secondary"
                @click="DetailReservation(item)"
              >
                <feather-icon size="14" icon="BookIcon" />
              </b-button>
              <b-button
                v-if="item.request_status === 'RESCHEDULE'"
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="warning"
                @click="RescheduleInfo(item)"
              >
                <feather-icon size="14" icon="ClockIcon" />
              </b-button>
             <b-button
                v-if="item.request_status === 'REQUESTED'"
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="primary"
                @click="deleteReservation(item)"
              >
                <feather-icon size="14" icon="TrashIcon" />
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" class="d-flex flex-wrap">
            <div style="font-size: 0.75rem;">
              <p><strong>CUSTOMER:</strong> {{ item.customer_name || '-' }}</p>
              <p><strong>PROJECT NAME:</strong> {{ item.project_name || '-' }}</p>
              <p>
                <strong>PORTFOLIO: </strong>
                <span :inner-html.prop="formatProduct(item.product_category, 'primary')"></span>
              </p>
              <p>
                <strong>PRODUCT NAME: </strong>
                <span :inner-html.prop="formatProduct(item.product_name, 'warning')"></span>
              </p>
              <p>
                <strong>REQUEST STATUS: </strong>
                <span :inner-html.prop="formatBadgesStatus(item.request_status)"></span>
              </p>
              <p><strong>RESERVATION:</strong> {{ item.date || '-' }}</p>
              <p><strong>CREATED AT:</strong> {{ item.createdat ? $moment(item.createdat).format('dddd, Do MMMM YYYY') : '-' }}</p>
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- Pagination Info -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-sm-start justify-content-center">
            <span class="text-muted">
              Showing
              {{ (currentPage - 1) * perPage + 1 }}
              to
              {{
                Math.min(currentPage * perPage, reservationRequest.length)
              }}
              of {{ reservationRequest.length }} entries
            </span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-sm-end justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="reservationRequest.length"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal
          title="Detail Reservation Request"
          hide-footer
          id="detail-reservation"
          size="lg"
          centered
          hide-header-close
        >
        <b-form>
          <b-row>
            <!-- AM Name + NIK -->
            <b-col md="6">
              <b-form-group>
                <template #label>
                  AM Name <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_am_name" id="am_name" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  NIK <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_nik" id="nik" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Segment/Witel + Division/TREG -->
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Segment <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_segmen_witel" id="witel" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Division/TREG <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_division_treg" id="division" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Phone Number + Email -->
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Phone Number <span class="text-danger">*</span>
                </template>
                <b-form-input type="tel" v-model="detail_phone_number" id="phone_number" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Email <span class="text-danger">*</span>
                </template>
                <b-form-input type="email" v-model="detail_email" id="email" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Project Name -->
            <b-col md="12">
              <b-form-group>
                <template #label>
                  Project Name <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_project_name" id="project_name" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Customer Name + Project Status -->
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Customer Name <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_customer_name" id="customer_name" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Project Status <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_project_status" id="project_status" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Date + Time -->
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Date <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_date" id="date" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Time <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_time" id="time" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Product Category + Product Name -->
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Portfolio <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_product_category" id="product_category" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Product Name <span class="text-danger">*</span>
                </template>
                <b-form-input v-model="detail_product_name" id="product_name" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <template #label>
                  Portfolio II
                </template>
                <b-form-input v-model="detail_product_category2" id="product_category2" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Product Name II
                </template>
                <b-form-input v-model="detail_product_name2" id="product_name2" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Notes -->
            <b-col md="12">
              <b-form-group label="Notes">
                <b-form-textarea v-model="detail_note" id="notes" placeholder="Ex. " rows="3" disabled />
              </b-form-group>
            </b-col>

            <!-- Submit Button -->
            <b-col class="d-flex justify-content-end">
              <b-button
                type="button"
                variant="light"
                class="mr-1"
                @click="$bvModal.hide('detail-reservation')"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <b-modal
          title="Detail Reschedule"
          hide-footer
          id="detail-reschedule"
          size="lg"
          centered
          hide-header-close
        >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Date
                </template>
                <b-form-input v-model="formReschedule.date_rescheduled_to" id="date_rescheduled_to" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Time
                </template>
                <b-form-input v-model="formReschedule.time_rescheduled_to" id="time_rescheduled_to" placeholder="Ex. " disabled required />
              </b-form-group>
            </b-col>

            <!-- Notes -->
            <b-col md="12">
              <b-form-group label="Notes">
                <b-form-textarea v-model="formReschedule.reschedule_note" id="reschedule_note" placeholder="Ex. " rows="3" disabled />
              </b-form-group>
            </b-col>

            <!-- Submit Button -->
            <b-col class="d-flex justify-content-end">
              <b-button
                type="button"
                variant="light"
                class="mr-1"
                @click="$bvModal.hide('detail-reschedule')"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormDatepicker,
  BPagination,
  BModal,
  VBModal,
  BFormTextarea,
  BImg,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import Ripple from 'vue-ripple-directive'
import moment from "moment";
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormDatepicker,
    BImg,
    VBModal,
    BFormTextarea,
    vSelect,
  },
  data() {
    return {
      token: "",
      detail_am_name: '',
      detail_customer_name: '',
      detail_division_treg: '',
      detail_email: '',
      detail_date: '',
      detail_nik: '',
      detail_note: '',
      detail_phone_number: '',
      detail_product_category: '',
      detail_product_name: '',
      detail_product_category2: '',
      detail_product_name2: '',
      detail_project_name: '',
      detail_project_status: '',
      detail_segmen_witel: '',
      detail_time: '',
      form: {
        id: 0,
        request_status: '',
        date: null,
        time: '',
        notes: '',
      },
      formReschedule: {
        date_rescheduled_to: '',
        reschedule_note: '',
        time_rescheduled_to: '',
      },
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      sortBy: 'CREATED_DATE',
      sortDesc: true,
      fields: [
        { key: 'am_name', label: 'AM Name' },
        { key: 'customer_name', label: 'Customer' },
        { key: 'project_name', label: 'Project Name' },
        { key: 'product_category', label: 'Portfolio' },
        { key: 'product_name', label: 'Product Name' },
        { key: 'request_status', label: 'Request Status' },
        { key: 'date', label: 'Reservation' },
        {
          key: 'createdat',
          formatter: (value, key, item) => {
            return this.$moment(value).format('YYYY-MM-DD H:mm')
          },
          label: 'Created At',
          sortable: true,
        },
        'action',
      ],
      reservationRequest: [],
      imgConsultativeSelling: require('@/assets/images/consultative-selling.png'),
      statuses: [
        { label: 'All', value: 'ALL' },
        { label: 'Requested', value: 'REQUESTED' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Reschedule', value: 'RESCHEDULE' },
      ],
      currentStatus: 'ALL',
    }
  },

  directives: {
    Ripple,
  },

  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },

  mounted() {
    this.fetchreservationRequest()
  },

  computed: {
    createdBy() {
      return this.$store.getters['oauth/getActiveUser'].id
    },
    filteredReservations() {
    if (this.currentStatus === 'ALL') {
      return this.reservationRequest
    }
    return this.reservationRequest.filter(item => item.request_status === this.currentStatus)
  },
  },

  methods: {
    fetchreservationRequest() {
      this.isBusy = true
      const createdBy = this.createdBy ? this.createdBy : this.$store.getters['oauth/getActiveUser'].id
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/createdby/`+createdBy, {
        params: {},
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      }).then(({ data }) => {
        this.reservationRequest = data.data.filter(item => item.is_deleted === null)
      }).finally(() => {
        this.isBusy = false
      })
    },
    sortingChanged({ sortBy, sortDesc}) {
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
      }
    },
    formatProduct(value, color) {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed
            .map(
              (cat) =>
                `<span class="badge badge-${color}" style="margin-right: 4px">${cat}</span>`
            )
            .join('');
        }
      } catch (e) {
        return `<span class="badge badge-${color}">${value}</span>`;
      }
    },
    formatBadgesStatus(value) {
      let color = 'primary'
      if (value === 'APPROVED') {
        color = 'success'
      } else if (value === 'REQUESTED') {
        color = 'info'
      } else if (value === 'RESCHEDULE') {
        color = 'primary'
      }
      return `<span class="badge badge-${color}">${value}</span>`;
    },
    DetailFormater(value, type) {
      try {
        const parsed = JSON.parse(value);
        if (parsed.length === 1) {
          if (type === 'category') {
            this.detail_product_category = parsed[0]
            this.detail_product_category2 = ""
          } else {
            this.detail_product_name = parsed[0]
            this.detail_product_name2 = ""
          }
        } else {
          if (type === 'category') {
            this.detail_product_category = parsed[0]
            this.detail_product_category2 = parsed[1]
          } else {
            this.detail_product_name = parsed[0]
            this.detail_product_name2 = parsed[1]
          }
        }
      } catch (e) {
        if (type === 'product') {
          this.detail_product_name = value
        } else {
          this.detail_product_category = value
        }
      }
    },
    RescheduleInfo(item) {
      this.formReschedule.date_rescheduled_to = ''
      this.formReschedule.reschedule_note = ''
      this.formReschedule.time_rescheduled_to = ''

      this.formReschedule.date_rescheduled_to = item.date_rescheduled_to
      this.formReschedule.reschedule_note = item.reschedule_note
      this.formReschedule.time_rescheduled_to = item.time_rescheduled_to
      this.$bvModal.show('detail-reschedule')
    },
    DetailReservation(item) {
      // set null
      this.detail_am_name = ''
      this.detail_customer_name = ''
      this.detail_division_treg = ''
      this.detail_email = ''
      this.detail_nik = ''
      this.detail_note = ''
      this.detail_phone_number = ''
      this.detail_project_name = ''
      this.detail_project_status = ''
      this.detail_segmen_witel = ''
      this.detail_time = ''
      this.detail_date = ''
      this.detail_product_name = ''
      this.detail_product_name2 = ''
      this.detail_product_category = ''
      this.detail_product_category2 = ''

      // add value
      this.detail_am_name = item.am_name
      this.detail_customer_name = item.customer_name
      this.detail_division_treg = item.division_treg
      this.detail_email = item.email
      this.detail_nik = item.nik
      this.detail_note = item.note
      this.detail_phone_number = item.phone_number
      this.detail_project_name = item.project_name
      this.detail_project_status = item.project_status
      this.detail_segmen_witel = item.segmen_witel
      this.detail_time = item.time
      this.detail_date = item.date
      this.DetailFormater(item.product_category, 'category')
      this.DetailFormater(item.product_name, 'product')
      this.$bvModal.show('detail-reservation')
    },
    filterByStatus(status) {
      this.currentStatus = status
      this.currentPage = 1
    },
    deleteReservation(item) {
      const id = item.id
      const url = `${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/${id}/softDelete`
      this.$bvModal.msgBoxConfirm(`Are you sure you want to delete reservation ID ${item.project_name}?`, {
        title: 'Confirm Delete',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.isBusy = true
          this.$http.put(url, {},{
            headers: {
              'Authorization': this.token,
              'Accept': 'application/json'
            }
          })
          .then((resp) => {
            console.log(resp)
            this.$bvToast.toast('Reservation deleted successfully.', {
              title: 'Deleted',
              variant: 'success',
              solid: true
            })
            this.fetchreservationRequest()
          })
          .catch((err) => {
            this.$bvToast.toast('Failed to delete reservation.', {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
            console.error(err)
          })
          .finally(() => {
            this.isBusy = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
